<div class="text-center">
    <img src="assets/img/StaffingGo.png" alt="Login" width="80%" class="img-responsive big-logo"
        *ngIf="isShowImgLogo === false">
    <img [src]="getImgLogo | safe:'resourceUrl'" alt="Login" width="80%" class="img-responsive big-logo"
        *ngIf="isShowImgLogo === true">
</div>
<div class="fz-18 text-center my-3 alert alert-success">
    <b>{{validEmailInfo && validEmailInfo.msg ? validEmailInfo.msg : 'Please, Enter OTP to verify your account'}}</b>
</div>
<div class="alert alert-danger text-center p-2 m-1" role="alert" *ngIf="errMsg">
    <div>{{errMsg}}</div>
</div>
<form (submit)="fnVerifyOTP(veriftOTPModel)">
    <dx-form id="form" [formData]="veriftOTPModel" [colCount]="4" labelLocation="top" [showColonAfterLabel]="false">
        <dxi-item [label]="{visible:false}" dataField="mailOTP" editorType="dxNumberBox"
            [editorOptions]="{ placeholder:'Enter OTP'}" [colSpan]="4">
            <dxi-validation-rule type="required" message="Email OTP is required"></dxi-validation-rule>
        </dxi-item>
        <!-- <dxi-item [label]="{text: 'SMS OTP'}" dataField="smsOTP" editorType="dxNumberBox" [colSpan]="4">
            <dxi-validation-rule type="required" message="SMS OTP is required"></dxi-validation-rule>
        </dxi-item> -->
        <dxi-item itemType="button" [colSpan]="4" [buttonOptions]="custVerify">
        </dxi-item>
    </dx-form>
</form>
<p class="mb-0 mt-2 text-center btnResendOTP">
    <a href="javascript:void(0)" (click)="fnResendOTP()">Resend OTP ?</a>
</p>
<p class="mb-0 mt-2 text-center btnLoginWPassword">
    <a href="javascript:void(0)" (click)="fnBackToLogin()">Remember password...?
        Login</a>
</p>